const colors = {
  orange: '#e98562',
  yellow: '#efc568',
  blue: '#3b84f1',
  purple: '#7467d1',
  lightPurple: '#9388db',
  lightGrayPurple: '#f7f7fb',
  lightPurpleAlpha: 'rgba(147, 134, 219, .5)',
  blackPurple: '#231d54',
  warmRed: '#fecec6',
  gray: '#707070',
  darkGray: '#2e3a4d',
  lightGray: '#edeff1',
  lightLightGray: '#e3e7ea',
  pink_to_purple:
    'linear-gradient(to right, rgba(255, 18, 102, .8), rgba(121, 101, 216, .8))',
  purple_to_purple: 'linear-gradient(to right, #9388db, #8200ff)',
  pink_to_yellow: 'linear-gradient(to right, #ff3c68, #ffb600)',
  blue_to_green: 'linear-gradient(to right, #424C57, #0EB88D)',
  green_to_green: 'linear-gradient(to right, #0E99B8, #0EB88D)',

  primaryColor: '#424C57',
  secondaryColor: '#BABABA',
  accentColorGreen: '#14CC9E',
  accentColorGreenLight: '#5BBFA6',
  accentColorOrange: '#FC6A49',
  textColorDark: '#232323',
  textColorWhite: '#FFFFFF',
  textColorGrey: '#BABABA',
  textColorLight: '#E8E8E8',
  backgroundColor: '#F3F3F3',
  backgroundColorWhite: '#FFFFFF',
}

export default colors
